import { useState } from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatDetail } from "@/lib/api";

/** 149-bp: Reopen WO yang berstatus cancelled_by_owner. Wajib isi alasan. */
export default function ReopenCancelledDialog({ open, onOpenChange, project, onDone }) {
  const [busy, setBusy] = useState(false);
  const [reason, setReason] = useState("");
  if (!project) return null;

  const submit = async () => {
    if (!reason.trim()) { toast.error("Alasan wajib diisi"); return; }
    setBusy(true);
    try {
      const { data } = await api.patch(`/active-projects/${project.id}/reopen-cancelled`, { reason: reason.trim() });
      toast.success(`WO dibuka kembali ke status ${data.restored_status || "aktif"}`);
      onOpenChange(false); setReason("");
      onDone?.();
    } catch (err) {
      toast.error(formatDetail(err.response?.data?.detail) || "Gagal membuka WO");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-none max-w-md" data-testid="reopen-cancelled-dialog">
        <DialogHeader>
          <DialogTitle className="font-display tracking-tight flex items-center gap-2 text-emerald-700">
            <RotateCcw size={18} /> Buka Kembali WO
          </DialogTitle>
        </DialogHeader>
        <div className="text-xs text-slate-500">
          WO <b className="text-[#0B1D3A]">{project.wo_number || project.id.slice(0, 6)}</b> — {project.wo_title || project.project_name}
        </div>
        <div className="space-y-1.5">
          <Label className="overline text-slate-600">Alasan Reopen <span className="text-rose-600 normal-case">*</span></Label>
          <textarea
            data-testid="reopen-reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Jelaskan mengapa WO dibuka kembali…"
            className="w-full border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:border-[#FF5A1F]"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-none" onClick={() => onOpenChange(false)}>Batal</Button>
          <Button data-testid="reopen-submit" onClick={submit} disabled={busy || !reason.trim()}
            className="rounded-none bg-emerald-700 hover:bg-emerald-800 disabled:opacity-50">
            {busy ? "Menyimpan…" : "Buka Kembali WO"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
